export default __webpack_public_path__ + "static/media/pexels-maria-frost-15733741.709fe0fe.jpg";